module.exports = __webpack_public_path__ + "static/media/font-size.dec29672.svg";